import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';

import FulfillmentInformation from 'cart/ui_components/FulfillmentInformation';

/**
 * Display location details for Dine-In cart.
 */
const CartDineIn = ({ restaurantName }) => (
  <Box data-testid="fulfillment-information" width="100%" mb={2}>
    <Box mb={1.5}>
      <Box display="inline">
        <FulfillmentInformation
          title="Dine-In Location"
          info={restaurantName}
        />
      </Box>
    </Box>
  </Box>
);

CartDineIn.propTypes = {
  /** Restaurant name */
  restaurantName: PropTypes.string.isRequired
};

export default CartDineIn;
